import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { dataSetAccentToneClass } from "./channel-data-set-accent-tone";
import type { FieldOption } from "./record-lens-utils";

/** A select option as the product prints it: a tinted badge with its dot. */
export function RecordOptionLabel({
  option,
  className,
}: {
  option: FieldOption;
  className?: string;
}) {
  return (
    <Badge
      variant="accent"
      className={cn(
        dataSetAccentToneClass(option.color),
        "min-w-0 max-w-full justify-start",
        className,
      )}
    >
      <span
        aria-hidden="true"
        className="size-1.5 shrink-0 rounded-full bg-[hsl(var(--ds-tone))]"
      />
      <span className="truncate">{option.label}</span>
    </Badge>
  );
}
